import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import initAuth from './auth-manager';

initAuth();

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
